export default __webpack_public_path__ + "static/media/CAPInstructionImage2.f047bc66.svg";